import { createAction } from 'redux/utils';
import { BU_ACTION_TYPES } from './business-units-types';
import { getBusinessUnits } from 'services/programs';

export const fetchBUsStart = () =>
    createAction(BU_ACTION_TYPES.FETCH_BUSINESS_UNITS_START);

export const fetchBUsSuccess = (payload) =>
    createAction(BU_ACTION_TYPES.FETCH_BUSINESS_UNITS_SUCCESS, payload);

export const fetchBUsFailed = (error) =>
    createAction(BU_ACTION_TYPES.FETCH_BUSINESS_UNITS_FAILED, error);

export const fetchBusinessUnitsAsync = async (dispatch) => {
    dispatch(fetchBUsStart());
    try {
        const businessUnits = await getBusinessUnits();
        dispatch(fetchBUsSuccess(businessUnits));
    } catch (error) {
        dispatch(fetchBUsFailed(error));
    }
};